import { motion } from "framer-motion";
import { EXPERTISES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";
import usePageContent from "@/hooks/usePageContent";

const ease = [0.16, 1, 0.3, 1];

export default function Expertise() {
    const t = usePageContent("home");
    return (
        <section
            id="expertise"
            data-testid="expertise-section"
            className="bg-[#FDFBF7] py-24 md:py-32"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 mb-20">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#DC2626]" />
                            <span className="overline">{t("expertise.overline", "01 · Votre intérieur")}</span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1E3A5F] leading-[1.05]">
                            {t("expertise.title", "Un studio,")}<br />
                            <span className="italic">{t("expertise.title_italic", "trois savoir-faire.")}</span>
                        </h2>
                    </div>
                    <div className="md:col-span-6 md:col-start-7 flex items-end">
                        <p className="text-[#64748B] text-lg leading-relaxed">
                            {t(
                                "expertise.description",
                                "De la conception à la pose, nous orchestrons chaque détail de votre projet — canapé, cuisine, salle à manger ou dressing — avec la rigueur d'un architecte et la patience d'un artisan. Chaque pièce est unique, pensée pour durer.",
                            )}
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
                    {EXPERTISES.map((e, i) => {
                        const layout = [
                            "md:col-span-7",
                            "md:col-span-5",
                            "md:col-span-12",
                        ][i];
                        return (
                            <motion.article
                                key={e.id}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.9, delay: i * 0.1, ease }}
                                className={`group relative ${layout}`}
                                data-testid={`expertise-card-${i}`}
                            >
                                <div className="img-zoom aspect-[4/3] md:aspect-[5/4] bg-[#F4F2EE]">
                                    <img
                                        src={e.image}
                                        alt={e.title}
                                        loading="lazy"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="mt-6 flex items-start justify-between gap-6">
                                    <div>
                                        <h3 className="font-serif text-2xl md:text-3xl text-[#1E3A5F]">
                                            {e.title}
                                        </h3>
                                        <p className="mt-3 text-[#64748B] text-base leading-relaxed max-w-md">
                                            {e.text}
                                        </p>
                                    </div>
                                    <div className="shrink-0 mt-2 w-11 h-11 border border-[#1E3A5F]/30 flex items-center justify-center text-[#1E3A5F] group-hover:bg-[#1E3A5F] group-hover:text-white transition-colors duration-500">
                                        <ArrowUpRight size={18} strokeWidth={1.5} />
                                    </div>
                                </div>
                            </motion.article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
